import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import InfoButton from "../../../components/buttons/InfoButton";
import { toDollars } from "../../../helpers/currencies";
import { CRMAppLocationIdentifier, FaqProps } from "../../../types/Faq";

const DossierBalances = ({
  pendingClaimsBalance,
  availableBalance,
  currentBalance,
  totalBalance,
  faqs,
  faqAppLocationIdentifiers,
}: {
  pendingClaimsBalance?: number;
  availableBalance?: number;
  currentBalance?: number;
  totalBalance?: number;
  faqs?: FaqProps;
  faqAppLocationIdentifiers?: {
    pendingClaims?: CRMAppLocationIdentifier;
    availableBalance?: CRMAppLocationIdentifier;
    currentBalance?: CRMAppLocationIdentifier;
    totalBalance?: CRMAppLocationIdentifier;
  };
}) => {
  const renderAppLocation = faqs?.renderAppLocation;

  const renderBalance = (
    balance: number,
    label: string,
    faqAppLocationIdentifier?: CRMAppLocationIdentifier
  ) => {
    const faqRenderer = faqAppLocationIdentifier && renderAppLocation;
    const labelElement = <Typography variant="bodyLarge">{label}</Typography>;
    const labelIcon = <InfoButton size="lg" />;
    const valueElement = (
      <Typography
        variant="bodyLarge"
        color={balance < 0 ? "secondary" : undefined}
      >
        {toDollars(balance, 2)}
      </Typography>
    );

    const renderedLabel = (
      <Box sx={{ display: "flex", gap: 1 }}>
        {faqRenderer
          ? faqRenderer(faqAppLocationIdentifier, labelElement)
          : labelElement}
        {faqRenderer
          ? faqRenderer(faqAppLocationIdentifier, labelIcon, true)
          : undefined}
      </Box>
    );

    const renderedValue = faqRenderer
      ? faqRenderer(faqAppLocationIdentifier, valueElement)
      : valueElement;

    return (
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        {renderedLabel}
        {renderedValue}
      </Box>
    );
  };

  const pendingClaimsBalanceRendered =
    pendingClaimsBalance !== undefined &&
    renderBalance(
      pendingClaimsBalance,
      "Pending Claims",
      faqAppLocationIdentifiers?.pendingClaims
    );
  const availableBalanceRendered =
    availableBalance !== undefined &&
    renderBalance(
      availableBalance,
      "Available for Expense Claims",
      faqAppLocationIdentifiers?.availableBalance
    );
  const currentBalanceRendered =
    currentBalance !== undefined &&
    renderBalance(
      currentBalance,
      "Balance Ex GST",
      faqAppLocationIdentifiers?.currentBalance
    );
  const totalBalanceRendered =
    totalBalance !== undefined &&
    renderBalance(
      totalBalance,
      "Total",
      faqAppLocationIdentifiers?.totalBalance
    );

  return (
    <Stack spacing={1}>
      {pendingClaimsBalanceRendered}
      {availableBalanceRendered}
      {currentBalanceRendered}
      {totalBalanceRendered}
    </Stack>
  );
};

export default DossierBalances;
